var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 32.1c-.1 0-.2-.1-.3-.2 0-.1-1.1-1.5-2.3-3.6-.7-1.2-1.2-2.4-1.6-3.6-.5-1.4-.7-2.8-.7-4.1 0-2.7 2.2-4.9 4.9-4.9s4.9 2.2 4.9 4.9c0 1.2-.2 2.6-.7 4.1-.4 1.1-.9 2.4-1.6 3.6-1.1 2.1-2.2 3.5-2.3 3.6-.1.1-.2.2-.3.2zm0-15.4c-2.2 0-4 1.8-4 4 0 2.6 1.2 5.4 2.2 7.2.7 1.4 1.5 2.4 1.9 3 .4-.6 1.1-1.7 1.9-3 1-1.8 2.2-4.6 2.2-7.2-.2-2.2-2-4-4.2-4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 23.2c-1.3 0-2.4-1.1-2.4-2.4 0-1.3 1.1-2.4 2.4-2.4 1.3 0 2.4 1.1 2.4 2.4 0 1.3-1.1 2.4-2.4 2.4zm0-4.1c-.9 0-1.6.7-1.6 1.6s.7 1.6 1.6 1.6c.9 0 1.6-.7 1.6-1.6s-.7-1.6-1.6-1.6z"
  })));
};
export default SvgPin;